"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultEdgeUrl = exports.DVSClientClass = void 0;
var dvsClient_1 = require("./dvsClient");
Object.defineProperty(exports, "DVSClientClass", { enumerable: true, get: function () { return dvsClient_1.DVSClientClass; } });
Object.defineProperty(exports, "getDefaultEdgeUrl", { enumerable: true, get: function () { return dvsClient_1.getDefaultEdgeUrl; } });
__exportStar(require("./types"), exports);
exports.default = new dvsClient_1.DVSClientClass();
//# sourceMappingURL=index.js.map